import { Popup, PopupDirection } from 'lego-on-react';
import React, { useRef, useState } from 'react';

import block from 'propmods';

import './HintPopup.scss';

const b = block('HintPopup');

interface Props {
    directions?: PopupDirection[];
    hint: React.ReactNode;
    when?: 'click' | 'hover';
}

export const HintPopup: React.FC<Props> = ({ children, hint, directions = ['right-center'], when = 'click' }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isMouseOver, setIsMouseOver] = useState(false);
    const ref = useRef<HTMLSpanElement>(null);

    const toggle = () => setIsVisible(!isVisible);

    return (
        <>
            <span
                ref={ref}
                onClick={when === 'click' ? toggle : undefined}
                onMouseEnter={when === 'hover' ? () => setIsMouseOver(true) : undefined}
                onMouseLeave={when === 'hover' ? () => setIsMouseOver(false) : undefined}
                {...b('content')}
            >
                {children}
            </span>
            <Popup
                hasTail
                autoclosable
                theme="normal"
                target="anchor"
                visible={isMouseOver || isVisible}
                anchor={() => ref.current}
                onOutsideClick={() => setIsVisible(false)}
                directions={directions}
            >
                <div {...b()}>{hint}</div>
            </Popup>
        </>
    );
};
